import { TFunction } from 'i18next'
import { configOptions } from './interfaces'

const TRANSLATION_BASE_FORM_KEY = 'userArea.profile.preferences'

interface OptionValues {
    alcoholInterest?: boolean
    activeMindInterest?: boolean
    auditiveCareInterest?: boolean
    clientLocalized?: number
    contactPredisposition?: number
    whatsappPermission?: number
    contact_11_to_13?: boolean
    contact_13_to_15?: boolean
    contact_15_to_17?: boolean
    contact_17_to_18?: boolean
    contact_9_to_11?: boolean
    contentPlatformInterest?: number
    earlyDetectionInterest?: boolean
    emailPreferred?: boolean
    emotionalBeingInterest?: boolean
    followUp?: number
    notes?: string
    neurodegenerativeIllInterest?: boolean
    newLinesInterest?: boolean
    nutritionInterest?: boolean
    ocularCareInterest?: boolean
    phoneCallPreferred?: boolean
    physicalActivityInterest?: boolean
    preventionPlanServiceInterest?: number
    preventivePowersServiceInterest?: number
    riskPlan?: number
    sleepInterest?: boolean
    socialActivityInterest?: boolean
    srConfidence?: number
    srServiceInterest?: number
    textPreferred?: boolean
    tobaccoInterest?: boolean
    whatsappPreferred?: boolean
    legalInformationInterest?: number
    curatorshipDetailInterest?: number
    advanceDirectivesDetailInterest?: number
    carePlanGuide?: number
    dependencyLawProcessing?: number
    homeAssessment?: number
}

export function updateConfigValues(options: configOptions, updatedValues: string | undefined) {
    return {
        ...options,
        value: updatedValues !== undefined ? updatedValues : '',
    }
}

export const clientStatusOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.statusClientTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.statusClient.locatable`),
                type: 'radio',
                value: 0,
                selected: values.clientLocalized === 0,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.statusClient.notLocatable`),
                type: 'radio',
                value: 1,
                selected: values.clientLocalized === 1,
            },
        ],
        type: 'radio',
        selected: values.clientLocalized,
        selectedRadioLabel: 
            values.clientLocalized === 0 
            ? t(`${TRANSLATION_BASE_FORM_KEY}.statusClient.locatable`) 
            : values.clientLocalized === 1 
            ? t(`${TRANSLATION_BASE_FORM_KEY}.statusClient.notLocatable`) 
            : '', 
    }
}

export const communicationPredisposablesOptions = (values: any) => (t: TFunction): configOptions => {


    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.predisposableCommunicationTitle`),
        },
        options: [
            {   label: t(`${TRANSLATION_BASE_FORM_KEY}.predisposableCommunication.yes`),
                type: 'radio',
                value: 0,
                selected: values.contactPredisposition === 0
            },
            {   label: t(`${TRANSLATION_BASE_FORM_KEY}.predisposableCommunication.no`),
                type: 'radio',
                value: 1,
                selected: values.contactPredisposition === 1
            },
        ],
        type: 'radio',
        selected: values.contactPredisposition,
        selectedRadioLabel:
            values.contactPredisposition === 0
            ? t(`${TRANSLATION_BASE_FORM_KEY}.predisposableCommunication.yes`)
            : values.contactPredisposition === 1
            ? t(`${TRANSLATION_BASE_FORM_KEY}.predisposableCommunication.no`)
            : '',
    }
}

export const whatsappPermissionOptions = (values: any) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermissionTitle`),
        },
        options: [
            {   label: t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermission.yes`),
                type: 'radio',
                value: 0,
                selected: values.whatsappPermission === 0
            },
            {   label: t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermission.no`),
                type: 'radio',
                value: 1,
                selected: values.whatsappPermission === 1
            },
            {   label: t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermission.no-information`),
                type: 'radio',
                value: 2,
                selected: values.whatsappPermission === 2
            },

        ],
        type: 'radio',
        selected: values.whatsappPermission,
        selectedRadioLabel:
            values.whatsappPermission === 0
            ? t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermission.yes`)
            : values.whatsappPermission === 1
            ? t(`${TRANSLATION_BASE_FORM_KEY}.whatsappPermission.no`)
            : '',
    }
}

export const preferedChannelOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    const selectedCheckboxLabels = [
        values?.textPreferred === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.text`) : '',
        values?.emailPreferred === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.email`) : '',
        values?.phoneCallPreferred === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.call`) : '',
        values?.whatsappPreferred === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.whatsapp`) : '',
    ]
    .filter(label => label)

    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannelTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.call`),
                type: 'checkbox',
                value: 'phone_call_preferred',
                selected: values.phoneCallPreferred || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.email`),
                type: 'checkbox',
                value: 'email_preferred',
                selected: values.emailPreferred || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.text`),
                type: 'checkbox',
                value: 'text_preferred',
                selected: values.textPreferred || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedChannel.whatsapp`),
                type: 'checkbox',
                value: 'whatsapp_preferred',
                selected: values.whatsappPreferred || false,
            },
        ],
        type: 'checkbox',
        selectedCheckboxLabels: selectedCheckboxLabels.length > 0 ? selectedCheckboxLabels : undefined,
    }
}

export const schedulePreferOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    const selectedCheckboxLabels =[
        values?.contact_9_to_11 === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.9a11`) : '', 
        values?.contact_11_to_13 === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.11a13`) : '', 
        values?.contact_13_to_15 === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.13a15`) : '',
        values?.contact_15_to_17 === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.15a17`) : '', 
        values?.contact_17_to_18 === true ? t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.17a18`) : '', 
    ]
    .filter(label => label)

    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetableTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.9a11`),
                type: 'checkbox',
                value:'contactNineToEleven',
                selected: values.contact_9_to_11 || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.11a13`),
                type: 'checkbox',
                value: 'contactElevenToThirteen',
                selected: values.contact_11_to_13 || false, 
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.13a15`),
                type: 'checkbox',
                value: 'contactThirteenToFifteen',
                selected: values.contact_13_to_15 || false, 
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.15a17`),
                type: 'checkbox',
                value: 'contactFifteenToSeventeen',
                selected: values.contact_15_to_17 || false, 
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.preferedTimetable.17a18`),
                type: 'checkbox',
                value: 'contactSeventeenToEighteen',
                selected: values.contact_17_to_18 || false, 
            },
        ],
        type: 'checkbox',
        selectedCheckboxLabels: selectedCheckboxLabels.length > 0 ? selectedCheckboxLabels : undefined,
    }
}

export const trustLevelOptions = (values: OptionValues) => (t: TFunction): configOptions => {
return {
    title: {
        label: t(`${TRANSLATION_BASE_FORM_KEY}.levelTrusteeTitle`),
    },
    options: [
        {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.low`),
            type: 'radio',          
            value: 0,
            selected: values.srConfidence === 0,
        },
        {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.medium`),
            type: 'radio',
            value: 1,
            selected: values.srConfidence === 1,
        },
        {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.high`),
            type: 'radio',
            value: 2,
            selected: values.srConfidence === 2,
        },
    ],
    type: 'radio',
    selected: values.srConfidence,
    selectedRadioLabel: (() => {
        switch (values.srConfidence) {
            case 0:
                return t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.low`)
            case 1:
                return t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.medium`)
            case 2:
                return t(`${TRANSLATION_BASE_FORM_KEY}.levelTrustee.high`)
            default:
                return undefined
        }
    })(),
    }
}

export const opOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.opTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.op.interested`),
                type: 'radio',
                value: 2,
                selected: values.srServiceInterest === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.op.doubts`),
                type: 'radio',
                value: 1,
                selected: values.srServiceInterest === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.op.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.srServiceInterest === 0,
            },
        ],
        type: 'radio',
        selected: values.srServiceInterest,
        selectedRadioLabel: (() => {
            switch (values.srServiceInterest) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.op.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.op.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.op.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const riskPlanOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.risksTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.risks.interested`),
                type: 'radio',
                value: 2,
                selected: values.riskPlan === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.risks.doubts`),
                type: 'radio',
                value: 1,
                selected: values.riskPlan === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.risks.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.riskPlan === 0,
            },
        ],
        type: 'radio',
        selected: values.riskPlan,
        selectedRadioLabel: (() => {
            switch (values.riskPlan) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.risks.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.risks.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.risks.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const contentPlanOptions = (values: OptionValues) => (t: TFunction): configOptions => {  
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.contentTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.content.interested`),
                type: 'radio',
                value: 2,
                selected: values.contentPlatformInterest === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.content.doubts`),
                type: 'radio',
                value: 1,
                selected: values.contentPlatformInterest === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.content.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.contentPlatformInterest === 0,
            },
        ],
        type: 'radio',
        selected: values.contentPlatformInterest,
        selectedRadioLabel: (() => {
            switch (values.contentPlatformInterest) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.content.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.content.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.content.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const followUpOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.followUpTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.followUp.interested`),
                type: 'radio',
                value: 2,
                selected: values.followUp === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.followUp.doubts`),
                type: 'radio',
                value: 1,
                selected: values.followUp === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.followUp.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.followUp === 0,
            },
        ],
        type: 'radio',
        selected: values.followUp,
        selectedRadioLabel: (() => {
            switch (values.followUp) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.followUp.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.followUp.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.followUp.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const infoPreventOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    const baseConfig = {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.preventitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.interested`),
                type: 'radio' as const,
                value: 2,
                selected: values.preventivePowersServiceInterest === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.doubts`),
                type: 'radio' as const,
                value: 1,
                selected: values.preventivePowersServiceInterest === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.noInterested`),
                type: 'radio' as const,
                value: 0,
                selected: values.preventivePowersServiceInterest === 0,
            },
        ],
        type: 'radio',
        selected: values.preventivePowersServiceInterest,
        selectedRadioLabel: (() => {
            switch (values.preventivePowersServiceInterest) {
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.prevent.noInterested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.prevent.doubts`)
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.prevent.interested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
        additionalOptions: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.legalInformation`),
                type: 'checkbox' as const,
                value: 'legal_information_interest',
                selected: values.legalInformationInterest === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.curatorship`),
                type: 'checkbox' as const,
                value: 'curatorship_detail_interest',
                selected: values.curatorshipDetailInterest === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.prevent.advanceDirectives`),
                type: 'checkbox' as const,
                value: 'advance_directives_detail_interest',
                selected: values.advanceDirectivesDetailInterest === 2,
            },
        ],
    }
    
    if (values.preventivePowersServiceInterest === 2) {
        const selectedCheckboxLabels = [
            values?.legalInformationInterest === 2 ? t(`${TRANSLATION_BASE_FORM_KEY}.prevent.legalInformation`) : '', 
            values?.curatorshipDetailInterest === 2 ? t(`${TRANSLATION_BASE_FORM_KEY}.prevent.curatorship`) : '', 
            values?.advanceDirectivesDetailInterest === 2 ? t(`${TRANSLATION_BASE_FORM_KEY}.prevent.advanceDirectives`) : '', 
        ].filter(label => label)

        return {
            ...baseConfig,
            type: 'checkbox',
            selectedRadioLabel: undefined,
            selectedCheckboxLabels: selectedCheckboxLabels.length > 0 ? selectedCheckboxLabels : undefined,
        }
    }

    return baseConfig
}

export const additionalServicesOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    const selectedCheckboxLabels =[
        values?.physicalActivityInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.physicalActivity`) : '', 
        values?.nutritionInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.food`) : '', 
        values?.alcoholInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.alcohol`) : '', 
        values?.emotionalBeingInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.wellness`) : '', 
        values?.auditiveCareInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.earCare`) : '', 
        values?.earlyDetectionInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.earlyDetection`) : '', 
        values?.neurodegenerativeIllInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.neurodegenerativeDiseases`) : '',
        values?.activeMindInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.activeMind`) : '',
        values?.tobaccoInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.tobacco`) : '', 
        values?.sleepInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.sleep`) : '', 
        values?.newLinesInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.research`) : '', 
        values?.ocularCareInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.eyeCare`) : '', 
        values?.socialActivityInterest === true ? t(`${TRANSLATION_BASE_FORM_KEY}.categories.social`) : '',
    ]
    .filter(label => label)

    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.categoriesTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.physicalActivity`),
                type: 'checkbox',
                value: 'physical_activity_interest',
                selected: values.physicalActivityInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.food`),
                type: 'checkbox',
                value: 'nutritionInterest',
                selected: values.nutritionInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.alcohol`),
                type: 'checkbox',
                value: 'alcoholInterest',
                selected: values.alcoholInterest || false, 
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.wellness`),
                type: 'checkbox',
                value: 'emotionalBeingInterest',
                selected: values.emotionalBeingInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.earCare`),
                type: 'checkbox',
                value: 'auditiveCareInterest',
                selected: values.auditiveCareInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.earlyDetection`),
                type: 'checkbox',
                value: 'earlyDetectionInterest',
                selected: values.earlyDetectionInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.neurodegenerativeDiseases`),
                type: 'checkbox',
                value: 'neurodegenerativeIllInterest',
                selected: values.neurodegenerativeIllInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.activeMind`),
                type: 'checkbox',
                value: 'activeMindInterest',
                selected: values.activeMindInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.tobacco`),
                type: 'checkbox',
                value: 'tobaccoInterest',
                selected: values.tobaccoInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.sleep`),
                type: 'checkbox',
                value: 'sleepInterest',
                selected: values.sleepInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.research`),
                type: 'checkbox',
                value: 'newLinesInterest',
                selected: values.newLinesInterest || false,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.eyeCare`),
                type: 'checkbox',
                value: 'ocularCareInterest',
                selected: values.ocularCareInterest || false, 
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.social`),
                type: 'checkbox',
                value: 'socialActivityInterest',
                selected: values.socialActivityInterest || false,
            },
        ],
        type: 'checkbox',
        selectedCheckboxLabels: selectedCheckboxLabels.length > 0 ? selectedCheckboxLabels : undefined,     
    }
}

export const notesOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.categoriesTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.categories.physicalActivity`),
                type: 'textarea',
                value: values.notes || ''
            },
        ],
        type: 'textarea',
    }
}

export const carePlanGuideOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuideTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.interested`),
                type: 'radio',
                value: 2,
                selected: values.carePlanGuide === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.doubts`),
                type: 'radio',
                value: 1,
                selected: values.carePlanGuide === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.carePlanGuide === 0,
            },
        ],
        type: 'radio',
        selected: values.carePlanGuide,
        selectedRadioLabel: (() => {
            switch (values.carePlanGuide) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.carePlanGuide.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const dependencyLawProcessingOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessingTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.interested`),
                type: 'radio',
                value: 2,
                selected: values.dependencyLawProcessing === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.doubts`),
                type: 'radio',
                value: 1,
                selected: values.dependencyLawProcessing === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.dependencyLawProcessing === 0,
            },
        ],
        type: 'radio',
        selected: values.dependencyLawProcessing,
        selectedRadioLabel: (() => {
            switch (values.dependencyLawProcessing) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.dependencyLawProcessing.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}

export const homeAssessmentOptions = (values: OptionValues) => (t: TFunction): configOptions => {
    return {
        title: {
            label: t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessmentTitle`),
        },
        options: [
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.interested`),
                type: 'radio',
                value: 2,
                selected: values.homeAssessment === 2,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.doubts`),
                type: 'radio',
                value: 1,
                selected: values.homeAssessment === 1,
            },
            {
                label: t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.noInterested`),
                type: 'radio',
                value: 0,
                selected: values.homeAssessment === 0,
            },
        ],
        type: 'radio',
        selected: values.homeAssessment,
        selectedRadioLabel: (() => {
            switch (values.homeAssessment) {
                case 2:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.interested`)
                case 1:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.doubts`)
                case 0:
                    return t(`${TRANSLATION_BASE_FORM_KEY}.homeAssessment.noInterested`)
                case null:
                case undefined:
                    return 'Información no proporcionada'
                default:
                    return undefined
            }
        })(),
    }
}
